import React from 'react';
import { Switch } from 'antd';

export var VincularCobrancaSwitch = function(props) {
    var checked = props.checked;
    var disabled = props.disabled;
    var onChange = props.onChange;
    var style = props.style || {};

    var wrapperStyle = Object.assign(
        { display: 'flex', alignItems: 'center', gap: 10, marginTop: 8, marginBottom: 6 },
        style
    );

    return (
        <div style={wrapperStyle}>
            <Switch
                checked={checked}
                disabled={disabled}
                onChange={onChange}
            />
            <span style={{ fontSize: 14, color: disabled ? '#bfbfbf' : '#262626' }}>
                Vincular cobrança
            </span>
        </div>
    );
};
